<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xyT4UK/tc-custom/9781526786357.jpg?1704516847219" alt="This image is the cover for the book Dawn of Aviation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dawn of Aviation
      </h1>
      <p class="bookDescription body article font2">
        <b>“This well-researched book evocatively conjures up the halcyon days of the swashbuckling amateurs who took to the skies in untested contraptions.” —<i>Sussex Life </i>magazine</b><br/><br/>Shoreham airport, founded in 1910, is the oldest airport in the UK and the oldest purpose-built commercial airport in the world. Yet aviation began in Sussex far earlier, with balloonists making landfall at Kingsfold near Horsham in 1785.<br/><br/><i>The Dawn of Aviation</i> recounts, in vivid style, the way in which successive generations of men—and women—carved out within the ancient and delightful county of Sussex, a memorable place in the history of British aviation. From balloons of the last 18th century, which were later employed by the military in 1880, to kites that could life a man into the air, to unmanned gliders, to the powered, controlled flight made possible by internal combustion engines in 1908, when Alec Ogilvie flew a Wright Brothers biplane along the coast at Camber, this well-researched, engaging account will appeal to aviation enthusiasts and British history buffs alike.<br/><br/>“An enjoyable and informative account of how flying originally came to the attractive corner of the UK.” —<i>The Aviation Historian</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josh Spoor, Roy Brooks
      </h2>
      
      <p class="authorDescription body article">Having lived in Sussex for many years, the late Roy Brooks developed a deep interest in the county’s aviation heritage. Over many years he delved deep into various archives and libraries to build up this remarkable insight into the early history of flight.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Air World
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70cda197